<template>
  <div class="form-section">
    <h3 class="form-section-label">{{ label }}</h3>
    <div class="form-section-container" :class="{ inline }">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'form-section',
  props: {
    label: String,
    anchor: String,
    inline: Boolean,
  },
}
</script>
<style lang="less">
.form-section {
  .form-section-label {
    font-size: 18px;
    border-bottom: 2px solid #cbcbcc;
    padding-bottom: 6px;
    margin-top: 0;
    margin-bottom: 20px;
  }
}
@media (min-width: 768px) {
  .form-section {
    .form-section-label {
      font-size: 26px;
      border-bottom: 2px solid #cbcbcc;
      padding-bottom: 6px;
      margin-top: 0;
      margin-bottom: 26px;
    }
    .form-section-container.inline {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
}
</style>